import { render, staticRenderFns } from "./IconCollapse.vue?vue&type=template&id=06916473&"
import script from "./IconCollapse.vue?vue&type=script&lang=js&"
export * from "./IconCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06916473')) {
      api.createRecord('06916473', component.options)
    } else {
      api.reload('06916473', component.options)
    }
    module.hot.accept("./IconCollapse.vue?vue&type=template&id=06916473&", function () {
      api.rerender('06916473', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCollapse.vue"
export default component.exports